
import BasicState from "src/libs/basic-view" 
import UtilitiesForms from "./local-works/UtilitiesForms"

export default class UtilitiesView extends BasicState {
    props: any
    addRender = () => {
        return <div className="container py-5">
            <UtilitiesForms {...this.props} />
        </div>
    }
}